import React, { useState } from 'react';
import { useRouteMatch, Route, Switch } from 'react-router-dom';

import SelectStory from './select-story';
import PasteProductUrls from './paste-product-urls';
import CopyLinks from './copy-links';
import ValidateLinks from './validate-links';
import CreatedLinks from './created-links';

import './create-links.scss';

const sections = [
  {
    label: 'Select a Post',
    value: 'select-story',
  },
  {
    label: 'Paste Product URLs',
    value: 'paste-product-urls',
  },
  {
    label: 'Validate Links',
    value: 'validate-links',
  },
  {
    label: 'Copy Links',
    value: 'copy-links',
  },
];

const CreateLinks = ({ location }) => {
  const { path } = useRouteMatch();
  const [selectedStory, setSelectedStory] = useState(null);
  const [oldLinks, setOldLinks] = useState('');
  const [newLinks, setNewLinks] = useState('');

  const urlParts = location.pathname.split('/');
  const activeSection = urlParts[urlParts.length - 1];

  const sectionValues = sections.map(section => section.value);

  const sectionNames = sectionValues.includes(activeSection) ? (
    <div className="section-names">
      {sections.map((section, idx) => (
        <div
          className={`name-icon ${idx <= sectionValues.indexOf(activeSection) ? 'active' : ''}`}
          key={idx}
        >
          <span className="idx-icon">{idx + 1}</span>
          <h2>{section.label}</h2>
        </div>
      ))}
    </div>
  ) : null;

  const header = sectionValues.includes(activeSection) ? (
    <div className="header">Create Links</div>
  ) : null;

  return (
    <div className="create-links-container">
      {header}
      {sectionNames}
      <div className="content">
        <Switch>
          <Route exact path={`${path}/select-story`}>
            <SelectStory selectedStory={selectedStory} setSelectedStory={setSelectedStory} />
          </Route>
          <Route path={`${path}/paste-product-urls`}>
            <PasteProductUrls
              selectedStory={selectedStory}
              setSelectedStory={setSelectedStory}
              oldLinks={oldLinks}
              setOldLinks={setOldLinks}
              location={location}
            />
          </Route>
          <Route path={`${path}/validate-links`}>
            <ValidateLinks
              setSelectedStory={setSelectedStory}
              oldLinks={oldLinks}
              selectedStory={selectedStory}
              setOldLinks={setOldLinks}
              location={location}
            />
          </Route>
          <Route exact path={`${path}/copy-links`}>
            <CopyLinks
              selectedStory={selectedStory}
              oldLinks={oldLinks}
              setOldLinks={setOldLinks}
              setNewLinks={setNewLinks}
            />
          </Route>
          <Route exact path={`${path}/created-links`}>
            <CreatedLinks
              setSelectedStory={setSelectedStory}
              oldLinks={oldLinks}
              setOldLinks={setOldLinks}
              newLinks={newLinks}
            />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default CreateLinks;
